import { lazy } from "react";
import { Navigate } from "react-router-dom";

// const FinOpsProcessOverview = lazy(() => import("pages/Processes/Overview/ProcessesOverview"));
// const FinOpsProcessDetails = lazy(() => import("pages/Processes/Details/ProcessDetails"));

export const finOps = [
  // {
  //   path: "/finops",
  //   element: <Navigate to="/finops/process/overview" replace />,
  // },
  // {
  //   path: "finops",
  //   children: [
  //     {
  //       path: "process/overview",
  //       element: <FinOpsProcessOverview />,
  //     },
  //     {
  //       path: "process/detail",
  //       element: <FinOpsProcessDetails />,
  //     },
  //   ],
  // },
];
